<template>
    <v-dialog v-model="openDialog" persistent max-width="500px" transition="dialog-transition">
        <v-card>
            <v-toolbar dense color="primary" dark>
                <v-toolbar-title>
                    Create Invoice {{ cbxType.text }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="$emit('closeModal')"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-row>
                    <v-col>
                        <v-combobox dense :items="types" v-model="type"  hide-details class="mx-3 mt-5"
                                label="Select Type" :item-text="'text'
                                " :item-value="'id'" return-object>
                        </v-combobox>
                        <v-combobox  dense :items="ordersNum" v-model="cbx" multiple hide-details class="mx-3 mt-5" append-outer-icon="mdi-list-status"
                                @click:append-outer="selectAll"
                                label="Select Order" :item-text="'OrderNumber'" :item-value="'OrderNumber'" return-object>
                        </v-combobox>
                    </v-col>
                </v-row>
                <v-row>
                    
                    <v-col>
                        <v-btn color="secondary" @click="createInvoice()">Save</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    props: ['ordersNum', 'openDialog','cbxType','InvId','searchInv'],
    data: function () {
        return {
            cbx: null,
            type:{
                id : 0,
                text :'Select a Type'
            },
            types: [
                {
                    text: 'Liters',
                    id: 1
                },
                {
                    text: 'Rate',
                    id: 2
                },
                {
                    text: 'FSC',
                    id: 3
                },
                {
                    text: 'Taxes',
                    id: 4
                },

            ],
        }
    },
    methods:{
        selectAll: function(){
            if(this.cbx == null){
                 this.cbx = this.ordersNum;
            }else{
                this.cbx = null;
            }
        },
        createInvoice: function (){
            var str = this.$store;
            var parms = {
                InvTypeID: this.cbxType.id,
                SubInvId : this.InvId.InvId,
                InvDate: this.InvId.InvDate,
                EndDate: this.InvId.EndDate,
                StartDate: this.InvId.StartDate,
                InvoiceGrp: this.InvId.InvoiceGrp,
                Customer : this.InvId.CustomerID,
                SubType: this.type.id,
                FSC: this.InvId.FSC,
                TVQPercent: this.InvId.TVQPercent,
                HSTPercent: this.InvId.HSTPercent,
                Orders: this.cbx
            }
            str.state.isLoading = true;
            axios
                .post('invoice/subInvoice/create', parms,{
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Create Invoice successful.'
                    });
                    this.searchInv = response.data.InvId;
                    str.state.isLoading = false;
                    this.$emit('search',this.searchInv)
                    this.$emit('close');
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        }
    },
    mounted() {
        console.log(this.InvId);
    }
}
</script>